import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { UserProfileEffects } from './user-profile.effects'

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [UserProfileEffects]
})
export class UserProfileStoreModule {}
